import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export interface IPPTCreateTipModel {
    isShow: boolean;
    tip: string;
    show: (payload: string) => void;
    hide: () => void;
}

const usePptCreateTipModel = create<IPPTCreateTipModel>()(
    immer((set) => ({
        isShow: false,
        tip: '',
        show: (payload) =>
            set((state) => {
                state.tip = payload;
                state.isShow = true;
            }),
        hide: () =>
            set((state) => {
                state.isShow = false;
            }),
    })),
);

export { usePptCreateTipModel };
export const getPptCreateTipModel = () => usePptCreateTipModel.getState();
